<template>
    <!-- 新增表格数据的dialog -->
    <div>
        <el-form :model="addForm" ref="addForm" :rules="rules" label-width="100px">
            <el-row>
                <el-col>
                    <el-form-item label="服务分类" prop="couponType">
                        <el-select v-model="addForm.couponType" placeholder="请选择服务分类">
                            <el-option v-for="item in couponType" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="服务名称" prop="couponName">
                        <el-input v-model.trim="addForm.couponName" placeholder="请输入服务名称"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="售卖价格" prop="couponPrice">
                        <el-input v-model.number="addForm.couponPrice" placeholder="请输入售卖价格"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="优惠金额" prop="couponMoney">
                        <el-input v-model.number="addForm.couponMoney" placeholder="请输入优惠金额"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="原价" prop="serverMoney">
                        <el-input v-model.number="addForm.serverMoney" placeholder="请输入原价"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="有效期" prop="expirationDate">
                        <el-select v-model="addForm.expirationDate" placeholder="请选择有效期">
                            <el-option v-for="item in date" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="已售数量" prop="sellNumber">
                        <el-input v-model.number="addForm.sellNumber" placeholder="请输入已售数量"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-form-item label="用券说明" prop="couponDescription">
                <quill-editor
                    v-model="addForm.couponDescription"
                    ref="myQuillEditor"
                    class="editor ql-editor editReset"
                    id="editor"
                    @change="onEditorChange($event)"
                    @keydown.native="onEditorKeyDown($event)"
                    @blur="onEditorblur()"
                ></quill-editor>
            </el-form-item>

            <el-form-item label="Logo图片" prop="couponLogoImg">
                <el-upload
                    class="avatar-uploader"
                    :action="uploadUrl"
                    :show-file-list="false"
                    :on-success="quaHandleAvatarSuccess"
                    :before-upload="quaBeforeAvatarUpload"
                    :on-change="uploadHandleChange"
                    :http-request="handleHttpRequest"
                    :auto-upload="false"
                >
                    <img v-if="imageUrl" :src="imageUrl" class="avatar" />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    <span class="el-upload__tip"> 温馨提示：建议上传一张宽高比为 3:2 的图片,建议：240px*160px</span>
                </el-upload>
            </el-form-item>
            <el-form-item label="服务图片" prop="couponServiceImg">
                <el-upload
                    :action="serveURL"
                    list-type="picture-card"
                    :on-success="imgSuccess"
                    :on-remove="imgRemove"
                    :file-list="imgFileList"
                    :before-upload="imgBefore"
                >
                    <i class="el-icon-plus"></i>
                    <div slot="tip" class="el-upload__tip">
                        温馨提示：最多上传5张照片，支持jpg,png类型的文件，单个照片大小不超过2M,比例为11：5,建议：330px*150px
                    </div>
                </el-upload>
                <el-dialog>
                    <img width="100%" :src="dialogImageUrl" alt="暂无图片" />
                </el-dialog>
            </el-form-item>
            <el-form-item label="购买须知" prop="purchaseNote">
                <quill-editor
                    v-model="addForm.purchaseNote"
                    ref="myQuillEditor"
                    class="editor ql-editor editReset"
                    id="editors"
                    @change="onEditorChange($event)"
                    @keydown.native="onEditorKeyDown($event)"
                    @blur="onEditorblur()"
                ></quill-editor>
            </el-form-item>
            <div class="dialog-footer">
                <el-button type="info" @click="resetForm('addForm')">取 消</el-button>
                <el-button type="primary" @click="submitForm('addForm')">确 定</el-button>
            </div>
        </el-form>
        <!-- 服务图片 -->
        <el-dialog title="图片剪裁" :visible.sync="dialogVisible" append-to-body :close-on-click-modal="false">
            <div class="cropper-content">
                <div class="cropper" style="text-align: center;">
                    <vueCropper
                        ref="cropper"
                        :img="options.img"
                        :outputSize="options.size"
                        :outputType="options.outputType"
                        :info="true"
                        :full="options.full"
                        :canMove="options.canMove"
                        :canMoveBox="options.canMoveBox"
                        :original="options.original"
                        :autoCrop="options.autoCrop"
                        :fixed="options.fixed"
                        :fixedNumber="options.fixedNumber"
                        :centerBox="options.centerBox"
                        :infoTrue="options.infoTrue"
                        :fixedBox="options.fixedBox"
                    ></vueCropper>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="changeScale(1)">+</el-button>
                <el-button @click="changeScale(-1)">-</el-button>
                <el-button @click="rotateLeft">↺</el-button>
                <el-button @click="rotateRight">↻</el-button>
                <el-button type="info" @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="finish">上传</el-button>
            </div>
        </el-dialog>
        <!-- Logo图片 -->
        <el-dialog title="图片剪裁" :visible.sync="loGOdialogVisible" append-to-body :close-on-click-modal="false">
            <div class="cropper-content">
                <div class="cropper" style="text-align: center;">
                    <vueCropper
                        ref="cropper"
                        :img="option.img"
                        :outputSize="option.size"
                        :outputType="option.outputType"
                        :info="true"
                        :full="option.full"
                        :canMove="option.canMove"
                        :canMoveBox="option.canMoveBox"
                        :original="option.original"
                        :autoCrop="option.autoCrop"
                        :fixed="option.fixed"
                        :fixedNumber="option.fixedNumber"
                        :centerBox="option.centerBox"
                        :infoTrue="option.infoTrue"
                        :fixedBox="option.fixedBox"
                    ></vueCropper>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="changeScale(1)">+</el-button>
                <el-button @click="changeScale(-1)">-</el-button>
                <el-button @click="rotateLeft">↺</el-button>
                <el-button @click="rotateRight">↻</el-button>
                <el-button @click="loGOdialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="finishs">上传</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { quillEditor } from 'vue-quill-editor';
import url from '../../../../constants/index';
console.log(url);
const titleConfig = [
    { Choice: '.ql-bold', title: '加粗' },
    { Choice: '.ql-italic', title: '斜体' },
    { Choice: '.ql-underline', title: '下划线' },
    { Choice: '.ql-header', title: '段落格式' },
    { Choice: '.ql-strike', title: '删除线' },
    { Choice: '.ql-blockquote', title: '块引用' },
    { Choice: '.ql-code', title: '插入代码' },
    { Choice: '.ql-code-block', title: '插入代码段' },
    { Choice: '.ql-font', title: '字体' },
    { Choice: '.ql-size', title: '字体大小' },
    { Choice: '.ql-list[value="ordered"]', title: '编号列表' },
    { Choice: '.ql-list[value="bullet"]', title: '项目列表' },
    { Choice: '.ql-direction', title: '文本方向' },
    { Choice: '.ql-header[value="1"]', title: 'h1标题' },
    { Choice: '.ql-header[value="2"]', title: 'h2标题' },
    { Choice: '.ql-align', title: '对齐方式' },
    { Choice: '.ql-color', title: '字体颜色' },
    { Choice: '.ql-background', title: '背景颜色' },
    { Choice: '.ql-image', title: '图像' },
    { Choice: '.ql-video', title: '视频' },
    { Choice: '.ql-link', title: '添加链接' },
    { Choice: '.ql-formula', title: '插入公式' },
    { Choice: '.ql-clean', title: '清除字体格式' },
    { Choice: '.ql-script[value="sub"]', title: '下标' },
    { Choice: '.ql-script[value="super"]', title: '上标' },
    { Choice: '.ql-indent[value="-1"]', title: '向左缩进' },
    { Choice: '.ql-indent[value="+1"]', title: '向右缩进' },
    { Choice: '.ql-header .ql-picker-label', title: '标题大小' },
    { Choice: '.ql-header .ql-picker-item[data-value="1"]', title: '标题一' },
    { Choice: '.ql-header .ql-picker-item[data-value="2"]', title: '标题二' },
    { Choice: '.ql-header .ql-picker-item[data-value="3"]', title: '标题三' },
    { Choice: '.ql-header .ql-picker-item[data-value="4"]', title: '标题四' },
    { Choice: '.ql-header .ql-picker-item[data-value="5"]', title: '标题五' },
    { Choice: '.ql-header .ql-picker-item[data-value="6"]', title: '标题六' },
    { Choice: '.ql-header .ql-picker-item:last-child', title: '标准' },
    { Choice: '.ql-size .ql-picker-item[data-value="small"]', title: '小号' },
    { Choice: '.ql-size .ql-picker-item[data-value="large"]', title: '大号' },
    { Choice: '.ql-size .ql-picker-item[data-value="huge"]', title: '超大号' },
    { Choice: '.ql-size .ql-picker-item:nth-child(2)', title: '标准' },
    { Choice: '.ql-align .ql-picker-item:first-child', title: '居左对齐' },
    {
        Choice: '.ql-align .ql-picker-item[data-value="center"]',
        title: '居中对齐'
    },
    {
        Choice: '.ql-align .ql-picker-item[data-value="right"]',
        title: '居右对齐'
    },
    {
        Choice: '.ql-align .ql-picker-item[data-value="justify"]',
        title: '两端对齐'
    }
];
export default {
    props: ['addData'],
    components: {
        quillEditor
    },

    data() {
        const couponPrice = (rule, value, callback) => {
            const age = /^[0-9]{1,5}([.][0-9]{1,2})?$/;
            if (!age.test(value)) {
                callback(new Error('售卖价格最大为5位整数，小数点保留后两位'));
            } else {
                callback();
            }
        };
        const couponMoney = (rule, value, callback) => {
            const age = /^[0-9]{1,5}([.][0-9]{1,2})?$/;
            if (!age.test(value)) {
                callback(new Error('优惠金额最大为5位整数，小数点保留后两位'));
            } else {
                callback();
            }
        };
        const serverMoney = (rule, value, callback) => {
            const age = /^[0-9]{1,5}([.][0-9]{1,2})?$/;
            if (!age.test(value)) {
                callback(new Error('原价最大为5位整数，小数点保留后两位'));
            } else {
                callback();
            }
        };
        const sellNumber = (rule, value, callback) => {
            console.log(value);
            console.log((value + '').length);
            const age = /^[1-9]\d*$/;
            if (!age.test(value)) {
                callback(new Error('已售数量为正整数'));
            } else if ((value + '').length > 5) {
                callback(new Error('已售数量最大为5位整数'));
            } else {
                callback();
            }
        };

        return {
            content: null,
            editorOption: {},
            date: [
                {
                    value: '-1',
                    label: '无期限'
                },
                {
                    value: '3',
                    label: '3天'
                },
                {
                    value: '7',
                    label: '7天'
                },
                {
                    value: '15',
                    label: '15天'
                }
            ],
            couponType: [
                {
                    value: '1',
                    label: '保养券'
                },
                {
                    value: '2',
                    label: '贴膜券'
                },
                {
                    value: '3',
                    label: '改装券'
                },
                {
                    value: '4',
                    label: '商品券'
                },
                {
                    value: '5',
                    label: '洗车券'
                },
                {
                    value: '6',
                    label: '其他'
                }
            ],
            // 新增表单数据
            addForm: {
                couponType: '',
                couponName: '', //优惠券名称
                couponPrice: '', //优惠券价格
                couponNumber: '', //优惠券数量
                serverMoney: '', //优惠金额
                expirationDate: '', //有效期
                couponDescription: '', //优惠券说明
                sellNumber: '', //已售数量
                merchantId: '', //商家ID
                couponLogoImg: '', //Logo图片ID
                couponServiceImg: '', //服务图片ID,
                purchaseNote: '' //购买须知
            },
            // 验证规则
            rules: {
                couponName: [
                    { required: true, message: '请输入服务名称', trigger: 'blur' },
                    { min: 2, max: 15, message: '长度在 2 到 15 个字符', trigger: 'blur' }
                ],
                couponPrice: [
                    { required: true, message: '请输入售卖价格', trigger: 'blur' },
                    { validator: couponPrice, trigger: 'blur' }
                ],
                couponMoney: [
                    { required: true, message: '请输入优惠金额', trigger: 'blur' },
                    { validator: couponMoney, trigger: 'blur' }
                ],
                serverMoney: [
                    { required: true, message: '请输入原价', trigger: 'blur' },
                    { validator: serverMoney, trigger: 'blur' }
                ],
                expirationDate: [{ required: true, message: '请选择有效期', trigger: 'change' }],
                // couponDescription: [{ required: true, message: '请输入优惠券说明', trigger: 'blur' }],
                sellNumber: [
                    // { required: true, message: '请输入已售数量', trigger: 'blur' },
                    {
                        validator: sellNumber,
                        trigger: 'blur'
                    }
                ],
                couponLogoImg: [
                    {
                        required: true,
                        message: '请上传商家图片',
                        trigger: 'change'
                    }
                ],
                couponServiceImg: [
                    {
                        required: true,
                        message: '请上传服务图片',
                        trigger: 'change'
                    }
                ],
                couponType: [{ required: true, message: '请选择服务分类', trigger: 'change' }]
                // purchaseNote: [{ required: true, message: '请输入购买须知', trigger: 'blur' }]
            },
            uploadUrl: 'upload/fileupload', //图片上传地址
            dialogImageUrl: '',
            limit: 5, //图片数量限制
            imageUrl: '',
            imgFileList: [],
            option: {
                img: '', // 裁剪图片的地址
                info: false, // 裁剪框的大小信息
                outputSize: 0.8, // 裁剪生成图片的质量
                outputType: 'jpeg', // 裁剪生成图片的格式
                canScale: true, // 图片是否允许滚轮缩放
                autoCrop: true, // 是否默认生成截图框
                autoCropWidth: 600, // 默认生成截图框宽度
                autoCropHeight: 700, // 默认生成截图框高度
                fixedBox: false, // 固定截图框大小 不允许改变
                fixed: false, // 是否开启截图框宽高固定比例
                // fixedNumber: [5.8, 6], // 截图框的宽高比例
                full: true, // 是否输出原图比例的截图
                canMoveBox: true, // 截图框能否拖动
                canMove: false,
                original: false, // 上传图片按照原始比例渲染
                centerBox: true, // 截图框是否被限制在图片里面
                infoTrue: true // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
            },
            options: {
                img: '', // 裁剪图片的地址
                info: false, // 裁剪框的大小信息
                outputSize: 0.8, // 裁剪生成图片的质量
                outputType: 'jpeg', // 裁剪生成图片的格式
                canScale: false, // 图片是否允许滚轮缩放
                autoCrop: true, // 是否默认生成截图框
                autoCropWidth: 160, // 默认生成截图框宽度
                autoCropHeight: 200, // 默认生成截图框高度
                fixedBox: false, // 固定截图框大小 不允许改变
                fixed: true, // 是否开启截图框宽高固定比例
                fixedNumber: [4.8, 5], // 截图框的宽高比例
                full: true, // 是否输出原图比例的截图
                canMoveBox: true, // 截图框能否拖动
                canMove: false,
                original: false, // 上传图片按照原始比例渲染
                centerBox: true, // 截图框是否被限制在图片里面
                infoTrue: true // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
            },
            dialogVisible: false, //图片裁剪的弹框dialog
            filename: '', //文件名
            loGOdialogVisible: false,
            logoFileName: '',
            actionUrl: '',
            url: '',
            fileList: [],
            serveURL: url.baseURL + 'upload/fileupload'
        };
    },
    created() {
        this.addForm.merchantId = this.addData;
        console.log(this.addForm.merchantId);
        console.log(this.addData);
    },
    mounted() {
        this.addQuillTitle();
        // 等页面dom元素加载完成后设置富文本编辑框的placeholder
        document.getElementById('editor').children[1].children[0].setAttribute('data-placeholder', '请输入用券说明');
        document.getElementById('editors').children[1].children[0].setAttribute('data-placeholder', '请输入购买须知');
    },
    methods: {
        submitForm(formName) {
            let that = this;
            console.log(that.addForm);

            that.addForm.couponServiceImg =
                that.addForm.couponServiceImg !== '' ? that.addForm.couponServiceImg.join(',') : that.addForm.couponServiceImg;
            console.log(typeof that.addForm.couponServiceImg);
            that.$refs.addForm.validate(valid => {
                if (valid) {
                    this.$axios
                        .post('coupon/save', {
                            couponType: that.addForm.couponType,
                            couponName: that.addForm.couponName,
                            couponPrice: that.addForm.couponPrice,
                            serverMoney: that.addForm.serverMoney,
                            couponMoney: that.addForm.couponMoney,
                            expirationDate: that.addForm.expirationDate,
                            couponDescription: that.addForm.couponDescription,
                            sellNumber: that.addForm.sellNumber,
                            merchantId: that.addData,
                            couponLogoImg: that.addForm.couponLogoImg, //Logo图片ID
                            couponServiceImg: that.addForm.couponServiceImg, //服务图片ID
                            purchaseNote: that.addForm.purchaseNote
                        })
                        .then(res => {
                            console.log(res);
                            if (res.data.code == 0) {
                                that.$message.success('新增成功');
                                that.$refs.addForm.resetFields();
                                that.imageUrl = '';
                                that.imgFileList = [];
                                that.$emit('dialog', false);
                            } else {
                                that.$message.error(res.data);
                            }
                            console.log(res);
                        });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        resetForm(formName) {
            let that = this;
            that.$confirm('确认放弃对当前页面信息的保存吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.$refs.addForm.resetFields();
                    this.dialogImageUrl = '';
                    this.imageUrl = '';
                    this.imgFileList = [];
                    this.$emit('dialog', false);
                })
                .catch(() => {});
        },
        resetFormData(formName) {
            this.$refs.addForm.resetFields();
            this.dialogImageUrl = '';
            this.imageUrl = '';
        },
        addQuillTitle() {
            document.getElementsByClassName('ql-editor')[0].dataset.placeholder = '';
            for (let item of titleConfig) {
                let tip = document.querySelector('.quill-editor ' + item.Choice);
                if (!tip) continue;
                tip.setAttribute('title', item.title);
            }
        },
        onEditorblur() {},
        // 富文本编辑器的change事件
        onEditorChange({ editor, html, text }) {},
        onEditorKeyDown(event) {},
        // 文件类型-会议照片
        regTypeImg(type) {
            switch (type) {
                case 'application/x-jpg':
                    return true;
                    break;
                case 'image/jpeg':
                    return true;
                    break;
                case 'image/png':
                    return true;
                    break;
                default:
                    return false;
                    break;
            }
        },
        // 点击已上传图片链接时的钩子
        imgPictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },

        imgSuccess(res, file, fileList) {
            console.log(res.data.url);
            this.imgFileList = fileList;
            this.dialogImageUrl = URL.createObjectURL(file.raw);
            if (res.code == 0) {
                let imgStr = [];
                fileList.forEach(item => {
                    console.log(item);
                    if (item.response) {
                        imgStr.push(item.response.data.id);
                    } else {
                        imgStr.push(item.id);
                    }
                });
                this.addForm.couponServiceImg = imgStr;
                console.log(this.imgFileList, 6666);
                console.log(this.addForm.couponServiceImg, 6666);
            } else {
                this.$message.error('上传失败');
                let index = fileList.indexOf(file);
                fileList.splice(index, 1);
            }
        },
        // 上传图片 -文件移除钩子
        imgRemove(file, fileList) {
            // this.imgFileList = fileList;
            if (file.status == 'success') {
                let imgStr = [];
                fileList.forEach(item => {
                    if (item.response) {
                        imgStr.push(item.response.data.id);
                    } else {
                        imgStr.push(item.id);
                    }
                });
                this.addForm.couponServiceImg = imgStr;
                // this.delResFile(fileKey, index, 3);
            }
        },
        handleChange(file, fileList) {
            // console.log(file);
            // let that = this;
            // this.fileList = fileList;
            // that.filename = file.name;
            // console.log(that.filename);
            // const isLt2M = file.size / 1024 / 1024 < 2;
            // const isIMG = ['.jpeg', '.jpg', '.png', '.bmp', '.gif', '.JPEG', '.JPG', '.GIF', '.PNG', '.BMP'].some(r =>
            //     file.name.endsWith(r)
            // );
            // if (!isIMG) {
            //     this.$message.error('上传图片只能是 jpg、jpeg、gif、 png、bmp 格式!');
            //     return false;
            // }
            // if (!isLt2M) {
            //     this.$message.error('上传图片大小不能超过 2MB!');
            //     return false;
            // }
            // let fileLen = that.imgFileList.length <= 4;
            // if (!fileLen) {
            //     that.$message.error('最多只能上传5张照片');
            //     return false;
            // }
            // this.$nextTick(() => {
            //     this.options.img = URL.createObjectURL(file.raw);
            //     this.dialogImageUrl = '';
            //     this.dialogVisible = true;
            // });
        },
        // 上传服务图片之前调用钩子
        imgBefore(file, fileList) {
            let that = this;
            let defineType = '';
            let isTure;
            if (file.type === '') {
                defineType = file.name.split('.')[1];
                isTure = that.regTypeImg(defineType);
            } else {
                isTure = that.regTypeImg(file.type);
            }
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isTure) {
                that.$message.error('暂不支持该文件类型!');
                return false;
            }
            if (!isLt2M) {
                that.$message.error('上传文件大小不能超过2M!');
                return false;
            }
            let fileLen = that.imgFileList.length <= 4;
            if (!fileLen) {
                that.$message.error('最多只能上传5张照片');
                return false;
            }
        },
        quaHandleAvatarSuccess() {},
        changeScale(val) {
            this.$refs.cropper.changeScale(val);
        },
        // 旋转图片
        rotateLeft() {
            this.$refs.cropper.rotateLeft();
        },
        rotateRight() {
            this.$refs.cropper.rotateRight();
        },
        //确定裁剪
        finish() {
            this.$refs.cropper.getCropData(res => {
                let file = this.dataURLtoFile(res, this.filename);
                console.log(file);
                this.handleHttpRequests(file);
                this.dialogVisible = false;
            });
        },
        // base64转file
        dataURLtoFile(dataurl, filename) {
            var arr = dataurl.split(','),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, { type: mime });
        },
        //上传事件
        async handleHttpRequests(file) {
            // alert(1);
            // console.log(file, 'file');
            // console.log(this.fileList);
            // let that = this;
            // console.log(file);
            // // console.log(fileList);
            // let formData = new FormData();
            // formData.append('file', file);
            // let config = {
            //     headers: {
            //         'Content-Type': 'multipart/form-data'
            //     }
            // };
            // const res = await this.$axios.post(that.uploadUrl, formData, config);
            // console.log(res);
            // if (res.data.code == 0) {
            //     let imgStr = [];
            //     imgStr.push(res.data.data.id);
            //     this.addForm.couponServiceImg = imgStr;
            //     this.imgFileList.push(res.data.data.url);
            //     console.log(this.imgFileList, 6666);
            //     // console.log(this.addForm.couponServiceImg, 6666);
            // } else {
            //     this.$message.error('上传失败');
            //     // let index = this.fileList.indexOf(file);
            //     // this.fileList.splice(index, 1);
            // }
        },
        //点击关闭按钮时关闭裁剪弹出框
        handleClose() {
            this.dialogVisible = false;
        },
        //logo图片上传
        quaBeforeAvatarUpload(file) {},
        uploadHandleChange(file) {
            // alert(5)
            this.logoFileName = file.name;
            const isLt2M = file.size / 1024 / 1024 < 2;
            const isIMG = ['.jpeg', '.jpg', '.png', '.bmp', '.gif', '.JPEG', '.JPG', '.GIF', '.PNG', '.BMP'].some(r =>
                file.name.endsWith(r)
            );
            if (!isIMG) {
                this.$message.error('上传图片只能是 jpg、jpeg、gif、 png、bmp 格式!');
                return false;
            }
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 2MB!');
                return false;
            }
            this.$nextTick(() => {
                this.option.img = URL.createObjectURL(file.raw);
                this.loGOdialogVisible = true;
            });
        },
        changeScale(val) {
            this.$refs.cropper.changeScale(val);
        },
        // 旋转图片
        rotateLeft() {
            this.$refs.cropper.rotateLeft();
        },
        rotateRight() {
            this.$refs.cropper.rotateRight();
        },
        //确定裁剪
        finishs() {
            this.$refs.cropper.getCropData(res => {
                let file = this.dataURLtoFile(res, this.logoFileName);
                this.handleHttpRequest(file);
                this.loGOdialogVisible = false;
            });
        },
        // base64转file
        dataURLtoFile(dataurl, filename) {
            var arr = dataurl.split(','),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, { type: mime });
        },
        //上传事件
        async handleHttpRequest(file) {
            let that = this;
            console.log(file);
            let formData = new FormData();
            formData.append('file', file);
            let config = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            };
            const res = await this.$axios.post(that.uploadUrl, formData, config);
            console.log(res);
            if (res.data.code == 0) {
                that.addForm.couponLogoImg = res.data.data.id;
                that.imageUrl = res.data.data.url;
            } else {
                this.$message.error(res.data);
            }
        },
        //点击关闭按钮时关闭裁剪弹出框
        handleClose() {
            this.dialogVisible = false;
        }
    }
};
</script>

<style lang="less" scoped>
.dialog-footer {
    text-align: right;
}
/deep/.el-input-number .el-input__inner {
    text-align: left;
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 148px;
    height: 148px;
    line-height: 148px;
    text-align: center;
    border: 1px dashed #d9d9d9;
}
.avatar {
    width: 148px;
    height: 148px;
    display: block;
}
.el-select {
    width: 100%;
}
.cropper-content .cropper {
    width: auto;
    height: 300px;
}
.upload_span {
    font-size: 12px;
}
</style>
